import { get, post } from "@/stores/dataManager/axios/axiosIndex";
import { axiosType } from "../../dataStore/memoryStore/const/constIndex"
import { getConfigFromWindowBrowser } from "@/utilities/utils";
import { ENV } from "@/utilities/EWindow";
import { buildQueryString } from "@/utilities";
const API_MARKET_URL = getConfigFromWindowBrowser(ENV.API_MARKET_URL)

const API = getConfigFromWindowBrowser(ENV.BASE_URL) ?? ''

const apiType = axiosType.CLIENT

const inqService = {
    getListMaster(params: { config: {}, typeOrder: string, searchQuery?: string, pageSize: number, pageIndex: number, custodycd: string, mtAcctno?: string }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            custodycd: params?.custodycd,
            mtAcctno: params?.mtAcctno ?? '',
            typeOrder: params?.typeOrder,
            mtFullname: params?.searchQuery ?? '',
            pageSize: params?.pageSize ?? 20,
            pageIndex: params?.pageIndex ?? 1,
        })
        return get(apiType, `${API}/cosapi/api/masters/listMaster?${query}`, options, config);
    },

    getRoleByAccount(params: { config: {}, custodycd: string }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            custodycd: params.custodycd
        })
        return get(apiType, `${API}/cosapi/api/inquiry/accountRole?${query}`, options, config);
    },

    getInvestPerformancePublic(params: { config: {}, accountId: string, masterAccount: string, cosrole: string, timePeriod: number, timeType: string }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            accountId: params.accountId,
            masterAccount: params.masterAccount,
            cosrole: params.cosrole, //F,
            timePeriod: params.timePeriod,
            timeType: params.timeType, // Y
        })
        return get(apiType, `${API}/cosapi/api/inquiry/investPerformance?${query}`, options, config);
    },

    getInvestPerformancePrivate(params: { config: {}, accountId: string, masterAccount: string, cosrole: string, timePeriod: number, timeType: string }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            // accountId: params.accountId,
            masterAccount: params.masterAccount,
            cosrole: params.cosrole, //F,
            timePeriod: params.timePeriod,
            timeType: params.timeType, // Y
        })
        return get(apiType, `${API}/cosapi/api/inquiry/accounts/${params.accountId ?? null}/investPerformance?${query}`, options, config);
    },

    ordersHistoryPublic(params: { config?: any, accountId: string, mtacctno: string, fromDate: string, toDate: string, pageIndex: number, pageSize: number }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            accountId: params.accountId,
            mtacctno: params.mtacctno,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageIndex: params.pageIndex,
            pageSize: params.pageSize || ''
        });
        return get(apiType, `${API}/cosapi/api/inquiry/ordersHistory?${query}`, options, config);
    },

    ordersHistoryPrivate(params: { config?: any, acctno: string, mtacctno: string, fromDate: string, toDate: string, pageIndex: number, pageSize: number }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            // acctno: params.acctno,
            mtacctno: params.mtacctno,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageIndex: params.pageIndex,
            pageSize: params.pageSize || ''
        });
        return get(apiType, `${API}/cosapi/api/inquiry/accounts/${params.acctno ?? null}/ordersHistory?${query}`, options, config);
    },

    accountRole(params: { config?: any, custodycd: string }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            custodycd: params.custodycd
        });
        return get(apiType, `${API}/cosapi/api/inquiry/accountRole?${query}`, options, config);
    },

    getConfigCos(params: { config?: any, }) {
        const options: any = {};
        const config: any = params?.config;
        return get(apiType, `${API}/cosapi/api/inquiry/cosConfig`, options, config);
    },

    masterPointPublic(params: { config?: any, accountId: string }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            accountId: params.accountId
        });
        return get(apiType, `${API}/cosapi/api/masters/getMasterPoint?${query}`, options, config);
    },

    masterPointPrivate(params: { config?: any, accountId: string }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            // accountId: params.accountId
        });
        return get(apiType, `${API}/cosapi/api/masters/accounts/${params.accountId ?? null}/getMasterPoint?${query}`, options, config);
    },

    investPerformance(params: { config?: any, accountId: string, masterCustodycd: string | null, cosrole: string, timePeriod: string, timeType: string }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            cosrole: params.cosrole,
            masterAccount: params.masterCustodycd,
            timePeriod: params.timePeriod,
            timeType: params.timeType
        });
        return get(apiType, `${API}/cosapi/api/inquiry/${params.accountId}/investPerformance?${query}`, options, config);
    },

    copyStatisticPublic(params: {
        config: {},
        accountId: string,
        periodTime: string,
        periodUnit: string
    }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            accountId: params?.accountId,
            periodTime: params?.periodTime,
            periodUnit: params?.periodUnit
        })
        return get(apiType, `${API}/cosapi/api/masters/getCopyStatistic?${query}`, options, config);
    },

    copyStatisticPrivate(params: {
        config: {},
        accountId: string,
        periodTime: string,
        periodUnit: string
    }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            // accountId: params?.accountId,
            periodTime: params?.periodTime,
            periodUnit: params?.periodUnit
        })
        return get(apiType, `${API}/cosapi/api/masters/accounts/${params?.accountId ?? null}/getCopyStatistic?${query}`, options, config);
    },

    pnlDailyPublic(params: {
        config: {},
        accountId: string,
        masterAccount: string,
        timePeriod: string | number,
        timeType: string
    }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            accountId: params?.accountId,
            masterAccount: params?.masterAccount,
            timePeriod: params?.timePeriod,
            timeType: params?.timeType
        })
        return get(apiType, `${API}/cosapi/api/inquiry/pnlDaily?${query}`, options, config);
    },

    pnlDaily(params: {
        config: {},
        accountId: string,
        masterAccount: string,
        timePeriod: string | number,
        timeType: string
    }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            // accountId: params?.accountId,
            masterAccount: params?.masterAccount,
            timePeriod: params?.timePeriod,
            timeType: params?.timeType
        })
        return get(apiType, `${API}/cosapi/api/inquiry/accounts/${params.accountId ?? null}/pnlDaily?${query}`, options, config);
    },

    getMasterDetail(params: { config: {}, typeOrder: string, acctno?: string }) {
        const options: any = {}
        const config: any = params?.config
        return get(apiType, `${API}/cosapi/api/masters/accounts/${params.acctno ?? null}/getMasterDetail?`, options, config);
    },

    getMasterThesis(params: { config: {}, acctno?: string }) {
        const options: any = {}
        const config: any = params?.config
        return get(apiType, `${API}/cosapi/api/masters/accounts/${params?.acctno ?? null}/getMasterInfo`, options, config);
    },

    postMasterInfo(params: { config: {}, masterAccountNo: string }, body: {
        shortInvestThesis?: string,
        investThesis?: string,
        investExperience?: string,
        minInvestAmt?: number,
        feeRate?: number,
        commissionRate?: number,
    }) {
        const config: any = params?.config;
        return post(apiType, `${API}/cosapi/api/masters/accounts/${params.masterAccountNo ?? null}/masterInfo`, { ...body, masterAccountNo: params.masterAccountNo }, config);
    },

    getAvlBuyPoint(params: { config: {}, acctno?: string }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            accountId: params.acctno
        })
        return get(apiType, `${API}/cosapi/api/masters/avl-buy-point?${query}`, options, config);
    },

    postAvlBuyPoint(params: { config: {} }, body: {
        avlBuyPoint: string,
        masterAccount: string
    }) {
        const config: any = params?.config;
        return post(apiType, `${API}/cosapi/api/masters/accounts/${body.masterAccount ?? null}/avl-buy-point`, body, config);
    },

    getCopierInfo(params: { config?: any, accountId: string, masterAccount: string }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            masterAccount: params.masterAccount
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${params.accountId}/copierInfo?${query}`, options, config);
    },

    getPreviewBeforeStopCopy(params: { config?: any, accountId: string, masterAccount: string }) {
        const options: any = {};
        const config: any = params?.config;
        const { accountId } = params
        const query = buildQueryString({
            masterAccount: params.masterAccount
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/reviewUncopy?${query}`, options, config);
    },

    getMoreInfoFollowers(params: { config?: any, accountId: string, masterAccount: string }) {
        const options: any = {};
        const config: any = params?.config;
        const { accountId } = params
        const query = buildQueryString({
            masterAccount: params.masterAccount
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/info?${query}`, options, config);
    },

    getCopyTransHist(params: {
        config?: any, accountId: string, masterAccount: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            // acctno: params.accountId,
            mtacctno: params.masterAccount,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex,
        });
        return get(apiType, `${API}/cosapi/api/inquiry/accounts/${params.accountId ?? null}/copyTransHist?${query}`, options, config);
    },

    getCopyHistoryService(params: {
        config?: any, acctno: string, mtacctno: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            acctno: params.acctno,
            mtacctno: params.mtacctno,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize || '',
            pageIndex: params.pageIndex,
        });
        return get(apiType, `${API}/cosapi/api/inquiry/copyTransHist?${query}`, options, config);
    },

    getTopCopyHistoryService(params: {
        config?: any, acctno: string, mtacctno: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            accountId: params.acctno,
            mtacctno: params.mtacctno,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize || '',
            pageIndex: params.pageIndex,
        });
        return get(apiType, `${API}/cosapi/api/inquiry/top-copy-trans-hist?${query}`, options, config);
    },

    getCommissionHistoryService(params: {
        config?: any, acctno: string,
        fromDate: string, toDate: string,
        pageSize: number, pageIndex: number
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize || '',
            pageIndex: params.pageIndex,
        });
        return get(apiType, `${API}/cosapi/api/masters/accounts/${params.acctno}/commission-hist?${query}`, options, config);
    },

    getPNLHistoryPublic(params: {
        config?: any, accountNo: string, masterAccount: string,
        fromDate: string, toDate: string
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            accountId: params.accountNo,
            masterAccount: params.masterAccount,
            fromDate: params.fromDate,
            toDate: params.toDate
        });
        return get(apiType, `${API}/cosapi/api/inquiry/pnlDetailsHist?${query}`, options, config);
    },

    getRankHistoryService(params: {
        config?: any, accountNo: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize === -1 ? '' : params.pageSize,
            pageIndex: params.pageIndex,
        });
        return get(apiType, `${API}/cosapi/api/masters/accounts/${params.accountNo}/rankHistory?${query}`, options, config);
    },

    getMasterReviewUnregis(params: { config?: any, accountId: string }) {
        const options: any = {};
        const config: any = params?.config;
        const accountId = params?.accountId ?? null
        const query = buildQueryString({});
        return get(apiType, `${API}/cosapi/api/masters/accounts/${accountId}/reviewUnregis?${query}`, options, config);
    },

    getPnlDetailsHist(params: {
        config?: any, accountId: string, masterAccount: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number
    }) {
        const options: any = {};
        const config: any = params?.config;
        const accountId = params.accountId ?? null
        const query = buildQueryString({
            masterAccount: params.masterAccount,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex,
        });
        return get(apiType, `${API}/cosapi/api/inquiry/accounts/${accountId}/pnlDetailsHist?${query}`, options, config);
    },

    getCashStatements(params: {
        config?: any, accountId: string, masterAccount: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number
    }) {
        const options: any = {};
        const config: any = params?.config;
        const accountId = params.accountId ?? null

        const query = buildQueryString({
            masterAccount: params.masterAccount,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex,
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/get-cash-statements?${query}`, options, config);
    },

    getStocksStatements(params: {
        config?: any, accountId: string, masterAccount: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number, symbol: string
    }) {
        const options: any = {};
        const config: any = params?.config;
        const accountId = params.accountId ?? null
        const query = buildQueryString({
            masterAccount: params.masterAccount,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex,
            symbol: params.symbol ?? 'ALL'
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/get-sec-statements?${query}`, options, config);
    },

    getAllocPortfolios(params: { config: {}, accountId: string, masterAccount: string, }) {
        const options: any = {}
        const config: any = params?.config
        const query = buildQueryString({
            accountId: params.accountId,
            // mtacctno: params.masterAccount,
        })
        return get(apiType, `${API}/cosapi/api/inquiry/getAllocPortfolios?${query}`, options, config);
    },

    getFeeManagement(params: {
        config?: any, accountId: string, masterAccount: string,
        fromDate: string, toDate: string, pageSize: number, pageIndex: number, status: string
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            masterAccount: params.masterAccount,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex,
            status: params.status
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${params.accountId ?? null}/fee-management/hist?${query}`, options, config);
    },

    getPortfoliosPrivate(params: { config?: any, accountId: string, pageSize: number, pageIndex: number, masterAccount: string | null }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            // accountId: params.accountId,
            masterAccount: params.masterAccount,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex || ''
        });
        return get(apiType, `${API}/cosapi/api/inquiry/accounts/${params.accountId ?? null}/getPortfolios?${query}`, options, config);
    },

    getPortfoliosSelfTotal(params: { config?: any, accountId: string, pageSize: number, pageIndex: number, masterAccount: string | null }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            // accountId: params.accountId,
            masterAccount: params.masterAccount,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex || ''
        });
        return get(apiType, `${API}/cosapi/api/inquiry/accounts/${params.accountId ?? null}/getPortfoliosAll?${query}`, options, config);
    },

    getCopyStuckStock(params: { config?: any, accountId: string, pageSize: number, pageIndex: number, masterAccount: string | null }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            // accountId: params.accountId,
            masterAccount: params.masterAccount,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex || ''
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${params.accountId ?? null}/get-copy-portfolios-stuck?${query}`, options, config);
    },

    getCopyOddLotStock(params: { config?: any, accountId: string, pageSize: number, pageIndex: number, masterAccount: string | null }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            // accountId: params.accountId,
            masterAccount: params.masterAccount,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex || ''
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${params.accountId ?? null}/get-copy-fractional-shares?${query}`, options, config);
    },

    getMasterCopyConfig(params: { config?: any, accountId: string, masterAccount: string | null }) {
        const options: any = {};
        const config: any = params?.config;
        const accountId = params?.accountId ?? null
        const query = buildQueryString({
            masterAccount: params.masterAccount,
        });
        return get(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/get-copy-cfg-detail?${query}`, options, config);
    },

};

export default inqService;